import { createSelector } from '@reduxjs/toolkit';
import { assetsNotDeleted } from './assets-not-deleted';
import type { OrganizationState } from '../../types';
import type { AssetViewModel } from '@trinnvis/dabih-api-client';
import type { LocalDate } from '../../../utilities/local-date';
import { sortBy } from 'lodash';

import { toAssetListItem } from './to-asset-list-item';
import { employeesShortNamesAndMe } from '../employees/employees-short-names-and-me';
import { events } from '../events/events';
import { getOrganization } from '../organization/getOrganization';
import { now } from '../organization/now';
import { contactsNotDeleted } from '../partners/contacts-not-deleted';

export const assetsWithTasks = createSelector(
  getOrganization,
  assetsNotDeleted,
  events,
  now,
  employeesShortNamesAndMe,
  contactsNotDeleted,
  function (
    organization: OrganizationState | undefined,
    assets: AssetViewModel[],
    events,
    now: LocalDate,
    employeeNames,
    contacts,
  ) {
    const o = organization;
    if (o === undefined) {
      return [];
    }
    return sortBy(assets, ['name', 'number']).map((asset) =>
      toAssetListItem(asset, events, now, employeeNames, contacts),
    );
  },
);
